import CardRankings from "../../../../src/components/card-rankings/CardRankings";
import afcRatings from "../../../../src/data/articles/cube-prospective-forgotten-realms-commander/afc-prospective-ratings.json";
import ProspectiveIntro from "../../../../src/components/article-elements/ProspectiveIntro.tsx";
import * as React from 'react';
export default {
  CardRankings,
  afcRatings,
  ProspectiveIntro,
  React
};